import {Box, Typography} from '@mui/material';
import React from 'react';

const SectionHeader = ({
                           title,
                           subtitle,
                           description,
                           titleVariant = "h6",
                           subtitleVariant = "body1",
                           descriptionVariant = "body1",
                           sx = {},
                           ...props
                       }) => {
    return (
        <Box sx={{ mb: 2, ...sx }} {...props}>
            <Typography
                variant={titleVariant}
                sx={{ fontWeight: "bold", fontVariant: "Gilroy-Bold" }}
            >
                {title}
                {subtitle && (
                    <Typography
                        variant={subtitleVariant}
                        component="span"
                        sx={{ fontWeight: "normal" }}
                    >
                        {' '}{subtitle}
                    </Typography>
                )}
            </Typography>
            {description && (
                <Typography variant={descriptionVariant}>
                    {description}
                </Typography>
            )}
        </Box>
    );
};

export default SectionHeader;